/**
 * Count Up
 */
export function count_up() {
	const elements = document.querySelectorAll('.count-up-no');

	elements.forEach((element) => {
		const start = parseInt(element.dataset.from || '0', 10);
		const end = parseInt(element.dataset.to || '0', 10);
		const duration = parseInt(element.dataset.duration || '2000', 10);

		let hasPlayed = false;

		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting || hasPlayed) {
						return;
					}

					hasPlayed = true;
					animateCountUp(start, end, duration, element);

					// 1度動いたら監視解除
					obs.unobserve(element);
				});
			},
			{
				threshold: 0.2,
			}
		);

		observer.observe(element);
	});

	function animateCountUp(start, end, duration, element) {
		const startTime = performance.now();
		const range = end - start;

		function easeOutCubic(t) {
			// return 1 - Math.pow(1 - t, 3);
      return 1 - Math.pow(1 - t, 4);
    }

		function update(currentTime) {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const easedProgress = easeOutCubic(progress);

			const currentValue = Math.round(start + range * easedProgress);
			element.textContent = currentValue.toLocaleString();

			if (progress < 1) {
				requestAnimationFrame(update);
			} else {
				element.textContent = end.toLocaleString();
			}
		}

		requestAnimationFrame(update);
	}
}